import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "juou-card" }

import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  useBaseAsync,
} from 'juou-managebase-ui';
import { ElMessage } from 'element-plus';
import { ref, watchEffect } from 'vue';
import dayjs from 'dayjs';
import { useApi } from '@/hooks/useApi';
import type { BlacklistAdminVo } from '@/api';

type BlacklistRow = BlacklistAdminVo & { id: number };


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<JuouProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof JuouProTable>>();
const loading = ref(false);
const addInitValue = {};
const conditionsInitValue = {};

const init = useBaseAsync(() => {
  columns.value = [
    {
      name: 'phone',
      label: '手机号',
      type: 'numberStr',
      isCondition: true,
      rule: [{ required: true, message: '请输入手机号' }],
    },
    {
      name: 'remark',
      label: '备注',
      type: 'string',
      isCondition: true,
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
      width: 165,
      render: ({ row }: { row: BlacklistRow }) => (row.createTime ? dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
    {
      name: 'updateTime',
      label: '更新时间',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
      width: 165,
      render: ({ row }: { row: BlacklistRow }) => (row.updateTime ? dayjs(row.updateTime).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
  ];
});

const getData = useBaseAsync<JuouProTableGetDataFunction>(async(filter: JuouProTableFilter) => {
  try {
    loading.value = true;
    const conditions = Object.entries(filter.conditions).reduce((result, [key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        result[key] = value;
      }
      return result;
    }, {} as Record<string, unknown>);
    const res = await useApi().blacklistApi.pageBlacklistBlacklist({
      conditions: conditions as Partial<BlacklistAdminVo>,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });
    return {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    } as JuouProTableData;
  } finally {
    loading.value = false;
  }
});

const addBlacklist = useBaseAsync(async(data: BlacklistAdminVo) => {
  await useApi().blacklistApi.addBlacklistBlacklist(data);
  ElMessage.success('已加入黑名单');
});

const updateBlacklist = useBaseAsync(async(data: BlacklistRow) => {
  await useApi().blacklistApi.updateBlacklistBlacklist(data);
  ElMessage.success('修改成功');
});

const deleteBlacklist = useBaseAsync(async(data: BlacklistRow) => {
  await useApi().blacklistApi.deleteBlacklistBlacklist(data.id);
  ElMessage.success('已移出黑名单');
});

const formatDeleteInfo = (row: BlacklistRow) => `您正在将手机号 ${row.phone} 移出黑名单，请谨慎操作`;

init();

watchEffect(() => {
  tableRef.value?.refresh();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(JuouProTable), {
      ref_key: "tableRef",
      ref: tableRef,
      title: "黑名单管理",
      paginations: { pageSize: 10 },
      columns: columns.value,
      "get-data": _unref(getData),
      "on-add": _unref(addBlacklist),
      "on-edit": _unref(updateBlacklist),
      "on-delete": _unref(deleteBlacklist),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id",
      "add-init-values": addInitValue,
      "codition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "on-add", "on-edit", "on-delete", "loading"])
  ]))
}
}

})